import client from "./httpClient";
import { SERVER_URL } from "../constants/Api";

const baseUrl = `${SERVER_URL}/self_registration_web`;

export const fetchIndex = async name => {
  const data = await client
    .get(`${baseUrl}?name=${name}`)
    .json();
  
  return data;
};

export const register = async ({
  name,
  grecaptchaToken,
  email,
  firstname,
  lastname,
  customValueFields
}) => {
   return await client
    .post(baseUrl, {
      json: {
        name,
        grecaptcha_token: grecaptchaToken,
        user_attributes: {
          email,
          firstname,
          lastname,
          user_field_values_attributes: customValueFields
        }
      }
    })
    .json();
};
